module.exports = __webpack_public_path__ + "static/media/ivy-full.7016d54d.png";